module.exports = __webpack_public_path__ + "static/img/step-3.f9c808f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-new/step-3.png
// module id = 1NH5
// module chunks = 4